import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Mutations, ShiftCMSState } from '@/store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { computed, markRaw, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';
import OrganizationForm from '../organizations/OrganizationForm.vue';
import { NEW_ID } from '@/util/constants';
import { Organization } from '@/models/organization.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationsList',
  setup(__props) {

const store = useStore<ShiftCMSState & { us: UsersState }>();

const communities = computed<Organization[]>(
  () => store.state.us.organizations,
);

const update = () => {
  store.dispatch(UsersActions.GetOrganizationsList);
};

const addOrganization = () => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(OrganizationForm),
    data: {
      id: NEW_ID,
      name: '',
      webToken: '',
      users: [],
    },
  });
};

function editOrganization(evt: Event, { item }: { item: Organization }) {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(OrganizationForm),
    data: item,
  });
}

onMounted(() => {
  update();
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
});

const headers = [
  { title: 'ID', key: 'id', width: '5%' },
  { title: 'Name', key: 'name', width: '15%' },
  { title: 'Users', key: 'users', width: '15%' },
  { title: 'Places', key: 'initiatives', width: '15%' },
  { title: 'Events', key: 'events', width: '15%' },
];

return (_ctx: any,_cache: any) => {
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Organizations", -1)),
      _createVNode(_component_v_data_table, {
        density: "compact",
        "onClick:row": editOrganization,
        headers: headers,
        items: communities.value,
        hover: ""
      }, {
        "item.users": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.users.length), 1)
        ]),
        "item.initiatives": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.initiatives.length), 1)
        ]),
        "item.events": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.events.length), 1)
        ]),
        _: 1
      }, 8, ["items"]),
      _createVNode(_component_v_btn, {
        onClick: addOrganization,
        color: "success"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Add Organization")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})